import React from "react";
import {printComponent, ProgressBar, Input} from "nq-component";
import {queryToObject} from "nq";
import Id from "./Id";

function App() {
    const [position, setPosition] = React.useState("MEMBER");
    const [objects, setObjects] = React.useState([]);
    const [progress, setProgress] = React.useState(0);
    const [frontImage, setFrontImage] = React.useState();
    const [backImage, setBackImage] = React.useState();
    const [primaryColor, setPrimaryColor] = React.useState("#000000");
    const [secondaryColor, setSecondaryColor] = React.useState("#ffffff");
    const ref = React.createRef();
    const refMultiple = React.createRef();
    const onChangeIds = (event) => {
        const files = Array.from(event.target.files);
        const lastPeriod = /\.[^/.]+$/;
        setObjects(files.map(file => {
            const picture = URL.createObjectURL(file);
            const object = queryToObject(file.name.replace(lastPeriod, ""));
            object.picture = picture;
            return object;
        }));
    };

    const onChangeFrontImage = (event) => {
        const file = event.target.files[0];
        setFrontImage(URL.createObjectURL(file));
    };

    const onChangeBackImage = (event) => {
        const file = event.target.files[0];
        setBackImage(URL.createObjectURL(file));
    };

    const onPrimaryColorChange = (value) => {
        setPrimaryColor(value);
    };

    const onSecondaryColorChange = (value) => {
        setSecondaryColor(value);
    };

    const onSubmitPrint = (event) => {
        event.preventDefault(); // Prevent default form submission
        printComponent(ref.current, {progress: v => setProgress((v * 100).toFixed())});
    };
    const onClickPrintMultiple = () => {
        printComponent(refMultiple.current, {progress: v => setProgress((v * 100).toFixed())});
    }

    return (<>
        <div className="d-none">
            <div ref={ref}>
                {objects.map((object, index) => (<Id
                    key={index}
                    frontImage={frontImage}
                    backImage={backImage}
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    object={object}
                    position={position}
                />))}
            </div>
        </div>
        <div className="d-none">
            <div ref={refMultiple} className="row">
                {objects.map((object, index) => {
                    const pagePos = (index % 9) + 1;
                    return (
                        <React.Fragment key={index}>
                            <div
                                className="col-3"
                                style={{
                                    marginBottom: pagePos === 9 ? "35mm" : 0,
                                    paddingTop: pagePos <= 3 ? "3mm" : 0,
                                }}>
                                <Id
                                    frontImage={frontImage}
                                    backImage={backImage}
                                    primaryColor={primaryColor}
                                    secondaryColor={secondaryColor}
                                    object={object}
                                    position={position}
                                    back={false}
                                />
                            </div>

                            {(index % 3) + 1 === 3 &&
                                <div
                                    className="col-3">
                                </div>
                            }

                        </React.Fragment>
                    );
                })}
            </div>


        </div>
        <div className="container mt-5">
            {progress > 0 && progress < 100 && (<div className="mt-1">
                <ProgressBar className="w-100" progress={progress}>
                    {progress}%
                </ProgressBar>
            </div>)}
            <h2>ID Upload Form</h2>
            <form onSubmit={onSubmitPrint}>
                <div className="row g-3">
                    <div className="col-md-4">
                        <label className="form-label fs-sm">Primary Color</label>
                        <Input
                            placeholder="Primary Color"
                            className="form-control-color"
                            type="color"
                            value={primaryColor}
                            onChange={onPrimaryColorChange}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label fs-sm">Secondary Color</label>
                        <Input
                            placeholder="Secondary Color"
                            className="form-control-color"
                            type="color"
                            value={secondaryColor}
                            onChange={onSecondaryColorChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label fs-sm">Position</label>
                        <Input
                            placeholder="Position"
                            type="string"
                            value={position}
                            onChange={setPosition}
                        />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="frontIdImage" className="form-label">Front ID Image</label>
                        <input
                            type="file"
                            className="form-control-file"
                            accept="image/*"
                            onChange={onChangeFrontImage}
                        />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="backIdImage" className="form-label">Back ID Image</label>
                        <input
                            type="file"
                            className="form-control-file"
                            accept="image/*"
                            onChange={onChangeBackImage}
                        />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="multipleFiles" className="form-label">Upload Additional Images</label>
                        <input
                            onChange={onChangeIds}
                            type="file"
                            className="form-control-file"
                            accept="image/*"
                            required
                            multiple
                        />
                    </div>
                </div>
                <button
                    type="submit"
                    className="btn btn-primary mt-3">
                    Print
                </button>
                <button
                    onClick={onClickPrintMultiple}
                    type="button"
                    className="btn btn-primary mt-3">
                    Print Multiple
                </button>
            </form>
        </div>
    </>);
}

export default App;
